import React, { useEffect } from 'react';
import FEMHero from '../../components/fem/FEMHero';
import FEMHighlights from '../../components/fem/FEMHighlights';
import FEMDetails from '../../components/fem/FEMDetails';
import FEMRegistration from '../../components/fem/FEMRegistration';
import FEMFreeEbook from '../../components/fem/FEMFreeEbook';
import FEMTestimonies from '../../components/fem/FEMTestimonies';
import FEMFAQs from '../../components/fem/FEMFAQs';
import FEMGallery from '../../components/fem/FEMGallery';
import catfish from '../../components/assets/catfish.jpg';

const SEO_CONFIG = {
  title: "Food Export Masterclass | Lagos School of Export Management",
  description: "Intensive 1-day training on exporting Nigerian foodstuffs (garri, beans, plantains) to Europe, US & Canada. Learn NAFDAC certification and international buyer acquisition in Lagos.",
  keywords: "Nigeria food export training, Lagos export workshop, one-day export seminar, SONCAP certification, food export documentation, foodstuff export, foodstuff export masterclass",
  canonicalUrl: "https://lsem.org.ng/fem",
  imageUrl: catfish,
};

const FoodstuffExportMasterclass = () => {
  useEffect(() => {
    // Update document title
    document.title = SEO_CONFIG.title;

    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', SEO_CONFIG.description);

    // Create canonical link if not exists
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', SEO_CONFIG.canonicalUrl);

    // Cleanup function
    return () => {
      // Optionally reset default title if needed
      document.title = "Lagos School of Export Management";
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Event",
          "name": SEO_CONFIG.title,
          "description": SEO_CONFIG.description,
          "startDate": "2024-06-15",
          "endDate": "2024-06-15",
          "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
          "eventStatus": "https://schema.org/EventScheduled",
          "location": {
            "@type": "Place",
            "name": "Lagos School of Export Management",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Lagos",
              "addressCountry": "NG"
            }
          },
          "offers": {
            "@type": "Offer",
            "price": "250000",
            "priceCurrency": "NGN"
          }
        })}
      </script>

      {/* Hidden SEO elements for crawlers */}
      <div className="sr-only">
        <h1>{SEO_CONFIG.title}</h1>
        <p>{SEO_CONFIG.description}</p>
        <ul>
          {SEO_CONFIG.keywords.split(', ').map((keyword, index) => (
            <li key={index}>{keyword}</li>
          ))}
        </ul>
      </div>

      {/* Page Content */}
      <header role="banner">
        <FEMHero />
      </header>

      <main role="main">
        <section aria-label="Program Highlights">
          <FEMHighlights />
        </section>

        <section aria-label="Masterclass Curriculum">
          <FEMDetails />
        </section>

        <section aria-label="Registration Information">
          <FEMRegistration />
        </section>

        <section aria-label="Free eBook Offer">
          <FEMFreeEbook />
        </section>

        <section aria-label="Student Testimonials">
          <FEMTestimonies />
        </section>

        <section aria-label="Frequently Asked Questions">
          <FEMFAQs />
        </section>

        <section aria-label="Photo Gallery">
          <FEMGallery />
        </section>
      </main>
    </div>
  );
};

export default FoodstuffExportMasterclass;